import React from "react";
import PT from "prop-types";
import { Link } from "@quintype/components";
import { getLinkTarget } from "../../../arrow/utils/utils";
import "./menu-item.m.css";

const MenuItem = ({ item, toggleHandler, menuStyle = "menu-link" }) => {
  const handleClick = (e) => {
    if (toggleHandler) toggleHandler(e); 
  };

  if (item["item-type"] === "placeholder") {
    return <span styleName="menu-link" className={menuStyle}>{item.title}</span>;
  } else if (item["item-type"] === "link") {
    const url = item.completeUrl || "/";
    return (
      <a
        onClick={handleClick}
        className={menuStyle}
        href={url}
        target={getLinkTarget(url)}
        rel="noopener"
      >
        {item.title}
      </a>
    );
  } else if (item["item-type"] === "section") {
    const url = item.url || "/";
    return (
      <Link
        aria-label="menu-item"
        callback={handleClick} // Ensure click closes menu
        className={menuStyle}
        href={url}
        target={getLinkTarget(url)}
        rel="noopener"
      >
        {item.title}
      </Link>
    );
  } else {
    const url = item.completeUrl || "/";
    return (
      <Link
        aria-label="menu-item"
        callback={handleClick} // Ensure click closes menu
        className={menuStyle}
        href={url}
        target={getLinkTarget(url)}
        rel="noopener"
      >
        {item.title}
      </Link>
    );
  }
};

MenuItem.propTypes = {
  item: PT.object.isRequired,
  toggleHandler: PT.func,
  menuStyle: PT.string
};

export { MenuItem };
